import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const link = ({ isActive }) => `text-sm font-medium tracking-wide ${isActive ? "text-black" : "text-neutral-600 hover:text-black"} transition-colors`;

  return (
    <header className="sticky top-0 z-40 glass border-b border-neutral-200/60" data-testid="site-navbar">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/logo.png" alt="Offline & Available" className="h-10 w-10 rounded-full object-cover" />
          <span className="font-heading text-lg tracking-tight hidden sm:inline">Offline &amp; Available</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/events" className={link} data-testid="nav-events">Events</NavLink>
          <NavLink to="/how-it-works" className={link} data-testid="nav-how-it-works">How it works</NavLink>
          <NavLink to="/faq" className={link} data-testid="nav-faq">FAQ</NavLink>
          <NavLink to="/contact" className={link} data-testid="nav-contact">Contact</NavLink>
          {user ? (
            <>
              <NavLink to="/dashboard" className={link} data-testid="nav-dashboard">Dashboard</NavLink>
              {user.role === "admin" && <NavLink to="/admin" className={link} data-testid="nav-admin">Admin</NavLink>}
              <Button onClick={() => { logout(); nav("/"); }} variant="outline" className="rounded-full" data-testid="nav-logout-btn">Log out</Button>
            </>
          ) : (
            <>
              <NavLink to="/login" className={link} data-testid="nav-login">Log in</NavLink>
              <Button onClick={() => nav("/signup")} className="rounded-full bg-black hover:bg-neutral-800 text-white" data-testid="nav-signup-btn">Sign up</Button>
            </>
          )}
        </nav>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-neutral-200/60 bg-white/95 px-6 py-4 space-y-4">
          {["events","how-it-works","faq","contact"].map(p => (
            <Link key={p} onClick={()=>setOpen(false)} to={`/${p}`} className="block text-neutral-800" data-testid={`nav-mobile-${p}`}>
              {p.replace("-", " ")}
            </Link>
          ))}
          {user ? (
            <>
              <Link onClick={()=>setOpen(false)} to="/dashboard" className="block" data-testid="nav-mobile-dashboard">Dashboard</Link>
              {user.role==="admin" && <Link onClick={()=>setOpen(false)} to="/admin" className="block" data-testid="nav-mobile-admin">Admin</Link>}
              <button onClick={()=>{logout();setOpen(false);nav("/");}} className="text-left w-full" data-testid="nav-mobile-logout">Log out</button>
            </>
          ) : (
            <>
              <Link onClick={()=>setOpen(false)} to="/login" className="block" data-testid="nav-mobile-login">Log in</Link>
              <Link onClick={()=>setOpen(false)} to="/signup" className="block font-semibold" data-testid="nav-mobile-signup">Sign up</Link>
            </>
          )}
        </div>
      )}
    </header>
  );
}
